const TriStateToggle = ({ value, onChange }) => {
  const label =
    value === "parent" ? "📷 Szülő"
      : value === "child" ? "🎬 Gyerek"
        : "📁 Mind";

  const cycle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (value === "parent") onChange("child");
    else if (value === "child") onChange("all");
    else onChange("parent");
  };

  return (
    <div
      className='form-control'
    >
      {/* Bal oldali gomb – fix szélesség */}
      <button
        style={{
          padding: "2px 8px",
          borderRadius: 4,
          border: "1px solid #ccc",
          background: "white",
          cursor: "pointer",
          width: '100%',              // <<< FIXÁLT SZÉLESSÉG
          // vagy "center", ha középre szeretnéd
        }}
        onClick={cycle}
      >
        {label}
      </button>



      {/* Jobb oldali "dummy" hely biztosítja a valódi középre igazítást */}
      <div style={{ width: 90 }}></div>
    </div>
  );
};

export default TriStateToggle;
